// extracted by mini-css-extract-plugin
export var header = "style-module--header--67BqR";
export var header_inner = "style-module--header_inner--9H3KB";
export var header_logo = "style-module--header_logo--thn2P";